module.exports = __webpack_public_path__ + "static/img/花瓶9.687de15.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶9.png
// module id = IJer
// module chunks = 2